<!-- eslint-disable -->
<template>
  <span>{{C_cpName}}</span>
</template>

<script>
/* eslint-disable */
export default {
  props: ["P_cpUid"],
  name: "ControlProcessorNameLabel",
  data() {
    return {
      DV_controlProcessorsMetadata: {}
    }
  },
  mounted() {
    const CI = this;
    CI.DV_controlProcessorsMetadata = window.G_web_gui_data.IV_control_processors_metadata;
  },
  computed: {
    C_cpName() {
      const CI = this;
      
      if (CI.P_cpUid === null || CI.P_cpUid === undefined) {
        return "Loading...";
      }

      const cp_uid = `cp_${CI.P_cpUid}`
      if (cp_uid in CI.DV_controlProcessorsMetadata === false) {
        return "Loading...";
      }

      if (CI.DV_controlProcessorsMetadata[cp_uid] === null || CI.DV_controlProcessorsMetadata[cp_uid] === undefined) {
        return "Loading...";
      }

      if ('name' in CI.DV_controlProcessorsMetadata[cp_uid]) {
        return CI.DV_controlProcessorsMetadata[cp_uid]['name'];
      } else {
        return `Loading: ${cp_uid}`
      }

      return "Loading...";
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/labels/ControlProcessorNameLabel.vue